module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "CONUS_Nitrate_07012018.5dedd26a.png";